import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/logo-left.png'
import _imports_1 from '../assets/images/centerLogo.png'
import _imports_2 from '../assets/images/logo-right.png'


const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modalInner" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"modalHeader\"><div class=\"leftLogo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"centerLogo\"><img src=\"" + _imports_1 + "\" alt=\"\"></div><div class=\"rightLogo\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div>", 1)
const _hoisted_4 = { class: "modalContent with-bg" }
const _hoisted_5 = { class: "modalContentInner" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"info\"><div class=\"show-desktop\"><p class=\"red\">How to play </p><p class=\"dark\">A key – UP <br>Z key – DOWN <br>. key – SHOOT</p><p class=\"dark\">Shoot the sprites to gain points. Don’t fly into them or you’ll lose a life! <br><br> Look out for the NetApp and Creative ITC logos - shoot them to replenish your health bar. <br><br> Good luck and make sure to register your score on the leader board!</p></div><div class=\"show-mobile\"><p class=\"red\">How to play</p><p class=\"dark\">Shoot the sprites to gain points. Don’t fly into them or you’ll lose a life! <br><br> Look out for the NetApp and Creative ITC logos - shoot them to replenish your health bar.<br><br> Good luck and make sure to register your score on the leader board!</p></div></div>", 1)
const _hoisted_7 = { class: "modalFooterIn" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn btn-large btn-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startLevel && _ctx.startLevel(...args)), ["prevent"])),
                  disabled: _ctx.loading
                }, _toDisplayString(_ctx.loading ? '...' : 'PLAY'), 9, _hoisted_8)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}